import { render, staticRenderFns } from "./EditCampaignArticle.vue?vue&type=template&id=460a686b&scoped=true&"
import script from "./EditCampaignArticle.vue?vue&type=script&lang=ts&"
export * from "./EditCampaignArticle.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "460a686b",
  null
  
)

export default component.exports